<div class="modal__content">
  <div class="confirmation-popup-header">
    <i class="fas {{headerIcon}}"></i>
    <span>{{ title }}</span>
  </div>
  <div [formGroup]="attestationForm" class="confirmation-popup-text">
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="attestation-checkbox"
        formControlName="attestationCheckbox">
      <label for="attestation-checkbox"
        class="form-check-label">{{ attestationText }}
      </label>
      @if (attestationForm.get('attestationCheckbox').hasError('required') &&
        attestationForm.get('attestationCheckbox').touched) {
        <div class="form-error-message"
          >
          Please confirm the attestation to complete the spread
        </div>
      }
    </div>
  </div>
</div>
<div class="modal__footer">
  <button type="reset" class="btn btn-link" (click)="closeModal();">{{ cancelButtonText }}</button>
  <button type="button" class="btn btn-primary"
    [ngClass]="{'btn-primary' : !danger, 'btn-danger': danger}"
    (click)="submitForm()">{{ confirmButtonText }}
  </button>
</div>
